import axios from "axios";
import { LOCAL_STORAGE } from "../utils/constants";

const CreatAxios = (props = {}) => {
  const congData = JSON.stringify({
    customerNumber: LOCAL_STORAGE.COOKIE_CUSTOMER_NO,
    userId: LOCAL_STORAGE.COOKIE_USER_ID,
    customer_no: +LOCAL_STORAGE.COOKIE_CUSTOMER_NO,
    customerNo: +LOCAL_STORAGE.COOKIE_CUSTOMER_NO,
    user_id: +LOCAL_STORAGE.COOKIE_USER_ID,
    ...props.payload
  });

  const apiURL = props.completeURL
    ? `${props.completeURL}`
    : `${process.env.APP_CONSTANT.BASE_COMMON}/${props.url}`;

  try {
    return new Promise((resolve, reject) => {
      axios.post(apiURL, congData, {
        headers: { 'content-type': 'application/json', 'Authorization': `${LOCAL_STORAGE.COOKIE_USER_TOKEN}`, "Access-Control-Allow-Origin": "*" }
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log("err", err.data);
          reject(err);
        });
    });
  } catch (error) {
    return console.log("Error Create", error);
  }
};

export default CreatAxios;
